import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveBodyshops, GetBodyshops } from './index';

// Api's
import { bodyshopApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getBodyshopsSaga(action: GetBodyshops) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      bodyshopApi.getBodyshopsOrBodyshopBranchesDomain,
      action.payload.request
    );
    if (response.data.result) {
      yield put(
        saveBodyshops(
          response.data.result,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveBodyshops(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}

